import { Box, Skeleton, useTheme } from '@mui/material';
import { ConversationMessageDraft, useConversationStatusOptions } from 'src/graphql';
import DraftItem from 'src/pages/Drafts/components/draft-item';

export interface DraftListProps {
  items: ConversationMessageDraft[];
  isLoading?: boolean;
  selectedId?: string | null;
  onOpen: (draft: ConversationMessageDraft) => void;
  onDelete: (draft: ConversationMessageDraft) => void;
}

export const DraftList = ({
  items,
  isLoading = false,
  selectedId,
  onOpen,
  onDelete,
}: DraftListProps) => {
  const theme = useTheme();
  const conversationStatusList = useConversationStatusOptions();
  const statusMap = new Map(conversationStatusList.map((i) => [i.id, i]));

  if (isLoading) {
    return (
      <Box borderBottom={`1px solid ${theme.palette.custom.OV.sys.outlineVariant}`}>
        {[...(Array(3) as number[])].map((i) => (
          <Box
            key={i}
            padding="0.5rem 1rem"
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Box display="flex" alignItems="center">
              <Box paddingRight="0.8rem" position="relative">
                <Skeleton variant="circular" width={28} height={28} />
              </Box>
              <Box display="flex" flexDirection="column">
                <Skeleton variant="text" width="120px" height={16} />
                <Skeleton variant="text" width="220px" height={16} />
              </Box>
            </Box>
            <Box display="flex" flexDirection="column">
              <Skeleton variant="text" width="40px" height={16} />
            </Box>
          </Box>
        ))}
      </Box>
    );
  }

  return (
    <Box display="flex" padding="1rem" gap="1rem" flexWrap="wrap" width="100%">
      {items.map((d) => {
        return (
          <DraftItem
            key={d.id}
            draft={d}
            isSelected={selectedId === d.id}
            onClick={onOpen}
            conversationStatus={statusMap.get(d.conversation?.conversationStatusId)}
            menuItems={[
              {
                id: 'delete',
                label: d.userId ? 'Delete' : 'Dismiss suggestion',
                icon: 'trash-2',
                iconLibrary: 'lucide',
                danger: Boolean(d.userId),
                onClick: () => onDelete(d),
              },
            ]}
          />
        );
      })}
    </Box>
  );
};
